export default __webpack_public_path__ + "static/media/product-detail-05.43fcd6e2.jpg";